import { WellnessPlanBenefits, WellnessPlanNames, WELLNESS_PLAN_BENEFIT_DETAILS } from '../../WellnessPlansSection/data';
enum Colors {
  Diamond = '#57c2ea',
  Gold = 'wagGold',
  Platinum = 'wagGray',
}
const {
  AnalGlandExpression,
  AnnualShotsBoosters,
  BloodDiagnosticTest,
  Deworming,
  PhysicalExam,
  VetChat,
  UrineFecalTest
} = WellnessPlanBenefits;

// TODO: Figure out how to combine data into one array and use a Masonry layout
export const wellnessBenefitsData1 = [{
  title: VetChat,
  labels: [{
    text: WellnessPlanNames.Platinum,
    bg: Colors.Platinum
  }, {
    text: WellnessPlanNames.Diamond,
    bg: Colors.Diamond
  }],
  body: WELLNESS_PLAN_BENEFIT_DETAILS[VetChat]
}, {
  title: AnnualShotsBoosters,
  labels: [{
    text: WellnessPlanNames.Gold,
    bg: Colors.Gold
  }, {
    text: WellnessPlanNames.Platinum,
    bg: Colors.Platinum
  }, {
    text: WellnessPlanNames.Diamond,
    bg: Colors.Diamond
  }],
  body: WELLNESS_PLAN_BENEFIT_DETAILS[AnnualShotsBoosters]
}, {
  title: Deworming,
  labels: [{
    text: WellnessPlanNames.Platinum,
    bg: Colors.Platinum
  }, {
    text: WellnessPlanNames.Diamond,
    bg: Colors.Diamond
  }],
  body: WELLNESS_PLAN_BENEFIT_DETAILS[Deworming]
}, {
  title: UrineFecalTest,
  labels: [{
    text: WellnessPlanNames.Platinum,
    bg: Colors.Platinum
  }, {
    text: WellnessPlanNames.Diamond,
    bg: Colors.Diamond
  }],
  body: WELLNESS_PLAN_BENEFIT_DETAILS[UrineFecalTest]
}];
export const wellnessBenefitsData2 = [{
  title: PhysicalExam,
  labels: [{
    text: WellnessPlanNames.Gold,
    bg: Colors.Gold
  }, {
    text: WellnessPlanNames.Platinum,
    bg: Colors.Platinum
  }, {
    text: WellnessPlanNames.Diamond,
    bg: Colors.Diamond
  }],
  body: WELLNESS_PLAN_BENEFIT_DETAILS[PhysicalExam]
}, {
  title: BloodDiagnosticTest,
  labels: [{
    text: WellnessPlanNames.Gold,
    bg: Colors.Gold
  }, {
    text: WellnessPlanNames.Platinum,
    bg: Colors.Platinum
  }, {
    text: WellnessPlanNames.Diamond,
    bg: Colors.Diamond
  }],
  body: WELLNESS_PLAN_BENEFIT_DETAILS[BloodDiagnosticTest]
}, {
  title: AnalGlandExpression,
  labels: [{
    text: WellnessPlanNames.Platinum,
    bg: Colors.Platinum
  }, {
    text: WellnessPlanNames.Diamond,
    bg: Colors.Diamond
  }],
  body: WELLNESS_PLAN_BENEFIT_DETAILS[AnalGlandExpression]
}];